import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const createNewSubscription = createAsyncThunk(
    'subscription/createNewSubscription',
    async (subscriptionData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(subscriptionData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/subscriptions/create-subscription`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getActiveSubscriptions = createAsyncThunk(
    'subscription/getActiveSubscriptions',
    async (_, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const response = await axios.get(`${PUBLIC_BASE_URL}/subscriptions/active-subscriptions`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const cancelSubscription = createAsyncThunk(
    'subscription/cancelSubscription',
    async (subscriptionCancelData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(subscriptionCancelData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/subscriptions/cancel-subscription`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);